import { render, staticRenderFns } from "./LicenseInfoCard.vue?vue&type=template&id=b5dab93e"
import script from "./LicenseInfoCard.vue?vue&type=script&lang=js"
export * from "./LicenseInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports